import React from 'react';
import { motion } from 'framer-motion';
import { Check, BarChart3, Repeat, ShieldCheck, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section id="oferta" className="py-20 bg-white" data-id="element-56">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="max-w-4xl mx-auto bg-[#2D2D2D] rounded-3xl overflow-hidden shadow-2xl text-white" data-id="element-58">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-59">
            <div className="p-8 md:p-12 flex flex-col justify-center bg-gradient-to-br from-[#2D2D2D] via-[#3D3D3D] to-[#2D2D2D]" data-id="element-60">
              <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-61">
                Recibe el sistema hoy
              </h2>
              <p className="text-gray-300 mb-8" data-id="element-62">
                Ideal para dueños ocupados: orden, porciones y bowls listos para
                repetir.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-63">
                {['Acceso inmediato', 'Menú especializado', 'Rutina clara sin improvisar'].map((item, i) => <li key={i} className="flex items-center" data-id="element-64">
                    <div className="bg-gradient-to-r from-[#D946EF] to-[#F0ABFC] rounded-full p-1.5 mr-3 shadow-lg shadow-[#D946EF]/30" data-id="element-65">
                      <Check className="w-3 h-3 text-white" data-id="element-66" />
                    </div>
                    <span className="font-medium text-white" data-id="element-67">{item}</span>
                  </li>)}
              </ul>

              <div className="flex flex-wrap gap-3 mt-auto" data-id="element-68">
                <div className="flex items-center text-xs text-white font-medium bg-[#D946EF]/20 border border-[#D946EF]/30 px-4 py-2 rounded-full" data-id="element-69">
                  <Repeat className="w-3.5 h-3.5 mr-2 text-[#F0ABFC]" data-id="element-70" />
                  Diseñado para repetirse
                </div>
                <div className="flex items-center text-xs text-white font-medium bg-[#D946EF]/20 border border-[#D946EF]/30 px-4 py-2 rounded-full" data-id="element-71">
                  <BarChart3 className="w-3.5 h-3.5 mr-2 text-[#F0ABFC]" data-id="element-72" />
                  Decisiones con datos
                </div>
              </div>
            </div>

            <div className="bg-[#FAE8FF] p-8 md:p-12 flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-73">
              {/* Decorative circle */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#D946EF]/20 rounded-full -mr-10 -mt-10 blur-xl" data-id="element-74" />

              <div className="relative z-10 w-full max-w-xs bg-white rounded-2xl p-6 shadow-xl" data-id="element-75">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D946EF] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-76">
                  Oferta Especial
                </div>

                <h3 className="text-xl font-bold text-[#2D2D2D] mt-2 mb-1" data-id="element-77">
                  Bowl Upgrade
                </h3>
                <p className="text-sm text-gray-500 mb-4" data-id="element-78">en 7 Días</p>

                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-79">
                  <span className="text-lg text-gray-400 line-through" data-id="element-80">
                    $59.85
                  </span>
                  <span className="text-4xl font-bold text-[#2D2D2D]" data-id="element-81">
                    $9.97
                  </span>
                </div>
                <p className="text-xs text-gray-400 mb-6" data-id="element-82">
                  Pago único · Acceso inmediato
                </p>

                <Button fullWidth className="mb-3 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all" onClick={() => window.open('https://bullygooddogs.com/cart/51339283890493:1/checkout', '_blank')} data-id="element-83">
                  Comprar ahora
                </Button>

                <p className="text-[10px] text-gray-400 leading-tight" data-id="element-84">
                  Este es un prototipo. El pago real se conectará cuando
                  publiques tu tienda.
                </p>
              </div>

              {/* Trust badges */}
              <div className="mt-8 flex items-center justify-center gap-6" data-id="element-85">
                <div className="flex flex-col items-center" data-id="element-86">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md mb-2" data-id="element-87">
                    <ShieldCheck className="w-6 h-6 text-[#D946EF]" data-id="element-88" />
                  </div>
                  <span className="text-xs text-[#666666] font-medium" data-id="element-89">
                    Satisfacción
                  </span>
                  <span className="text-xs text-[#666666]" data-id="element-90">Garantizada</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-91">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md mb-2" data-id="element-92">
                    <div className="flex" data-id="element-93">
                      {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-94" />)}
                    </div>
                  </div>
                  <span className="text-xs text-[#666666] font-medium" data-id="element-95">
                    5 Estrellas
                  </span>
                  <span className="text-xs text-[#666666]" data-id="element-96">Valoración</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}